import React, { useMemo } from 'react';
import { useTheme, Box, Theme } from '@mui/material';
import { Activity } from '../../models/activity';
import { getIntervalDayForWeekAccording } from '../../services/dateService';
import { ActivityWeekTask } from './activityWeekTask';
import { format } from 'date-fns';
import useDaysOff from '../../hooks/useDaysOff';
import { ViewMode } from '../../models/preferences';
import { getTargetHoursToWork } from '../../services/activityService';
import {
   formatDateOnly,
} from '../../services/dateService';

const makeStyle = (theme: Theme) => ({
  box: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
});

interface Props {
  location?: string;
  isWorkWeek?: boolean;
  activities: Activity[];
  dateActivity: Date;
  onSelectDay(activityDate: string): void;
  showOnlyloggedTime?: boolean;
  employeeWorkHours?: number;
}

export function ActivityWeek({
  activities,
  dateActivity,
  location,
  onSelectDay,
  isWorkWeek = false,
  showOnlyloggedTime = false,
  employeeWorkHours,
}: Props): JSX.Element {
  const theme = useTheme();
  const style = makeStyle(theme);

  const { targetHolidays } = useDaysOff({
    targetDate: dateActivity,
    country: location || '',
    mode: ViewMode.WEEK,
    // isWorkWeek,
  });

  const activityTasks = useMemo(() => {
    const intervalDays = getIntervalDayForWeekAccording(
      isWorkWeek,
      dateActivity
    );

    return intervalDays.map((day) => ({
      day,
      activitiesData: activities.filter(
        (activity) =>
          format(new Date(formatDateOnly(day)), 'iii') ===
          format(new Date(formatDateOnly(activity.date)), 'iii')
      ),
      dayOff: targetHolidays?.find(
        (dayOff) =>
          format(new Date(formatDateOnly(day)), 'iii') ===
          format(new Date(formatDateOnly(dayOff.dayOffDate)), 'iii')
      ),
      targetHoursToWork: (!showOnlyloggedTime && employeeWorkHours) 
        ? getTargetHoursToWork(
          new Date(formatDateOnly(day)),
          targetHolidays,
          location || '',
          employeeWorkHours) 
        : 0,
    }));
  }, [isWorkWeek, dateActivity, activities, targetHolidays, location, employeeWorkHours, showOnlyloggedTime]);

  return (
    <Box sx={style.box}>
      {activityTasks.map(
        ({ day, activitiesData, dayOff, targetHoursToWork }) => (
          <ActivityWeekTask
            key={day}
            dayWeek={day}
            activities={activitiesData}
            onSelectDay={onSelectDay}
            dayOff={dayOff}
            targetHoursToWork={targetHoursToWork}
            showOnlyloggedTime={showOnlyloggedTime}
          />
        )
      )}
    </Box>
  );
}
